/* eslint-disable no-unused-vars */
/* eslint-disable prefer-destructuring */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable no-underscore-dangle */
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import userServices from '../../../../redux/services/userServices';
import { Loading } from '../../../../helpers/utils';
import StudentsList from './StudentsList';
import StudentsInGroupList from './StudentsInGroupList';

const AddStudents = ({ groupId, group, company }) => {
  const [tableData, setTableData] = useState([]);
  const [groupStudents, setGroupStudents] = useState([]);
  const [loaded, setloaded] = useState(false);

  const loadData = async () => {
    setloaded(false);
    setTableData([]);
    const res = await userServices.getStudentsWithoutGrade(company._id);
    const studentsInGroupArr = [];
    const studentsInCompanyArr = [];
    if (res.groups && res.groups.length > 0) {
      res.groups.forEach((groupItem) => {
        if (groupItem.id === groupId && groupItem.user && groupItem.user.length > 0) {
          groupItem.user.forEach((user) => {
            res.tests.forEach((student) => {
              if (user === student._id) {
                studentsInGroupArr.push(student);
              }
            });
          });
        }
      });
    }
    if (res.tests && res.tests.length > 0) {
      res.tests.forEach((studentInCompany) => {
        let found = false;
        studentsInGroupArr.forEach((studentInGroup) => {
          if (studentInCompany._id === studentInGroup._id) {
            found = true;
          }
        });
        if (found === false) {
          studentsInCompanyArr.push(studentInCompany);
        }
      });
    }
    setTableData(studentsInCompanyArr);
    setGroupStudents(studentsInGroupArr);
    setloaded(true);
  };

  useEffect(() => {
    loadData();
  }, []);

  return (
    <div>
      {loaded === false
        ? <Loading />
        : (
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'stretch',
              gap: '15px',
              justifyContent: 'center',
            }}
          >
            <StudentsList groupId={groupId} students={tableData} loadData={loadData} />
            <StudentsInGroupList groupId={groupId} students={groupStudents} loadData={loadData} />
          </div>
        )}

    </div>
  );
};

AddStudents.propTypes = {
  groupId: PropTypes.string.isRequired,
  group: PropTypes.object.isRequired,
  company: PropTypes.object.isRequired,
};

function mapState(state) {
  const groupId = state.group.selectedGroup._id;
  const group = state.group.selectedGroup;
  const { company } = state.company;
  return { groupId, group, company };
}

const actionCreators = {};

const connectedAddStudents = connect(mapState, actionCreators)(AddStudents);

export default withRouter(connectedAddStudents);
